projectFunctions.downloadsLagFilterFunctions = projectFunctions.downloadsLagFilterFunctions || {};

/**
 * Init: Will be triggered on document ready.
 */
projectFunctions.downloadsLagFilterFunctions.init = function() {
    this.downloadsLangFilter();
    this.filterDownloads();
};

projectFunctions.downloadsLagFilterFunctions.downloadsLangFilter = function (downloadsId) {
  const dropwdowns = document.querySelectorAll('.downloads-dropdown');
  
  if(!dropwdowns) return;

  dropwdowns.forEach(dropwdown => {
    const filter = dropwdown.querySelector('select');

    filter.addEventListener('change', () => {
      this.filterDownloads();
    })
  });
}

projectFunctions.downloadsLagFilterFunctions.filterDownloads = function(downloadsId) {
  const filterContainer = document.querySelector('.downloads-filters-container');
  
  if(!filterContainer) return;

  const lang = document.querySelector('#download-lang');
  const type = document.querySelector('#download-type');
  const langValue = lang.value;
  const typeValue = type.value;
  const downloads = downloadsId ? downloadsId : filterContainer.dataset.downloads;
  const downloadsContainer = document.querySelector('#product-downloads');
  
  $.ajax({
    type: 'POST',
    url: AjaxMethodsUrl,
    data: {
      action: 'filter_downloads',
      downloads: downloads,
      wpml_lang: wpml_data.lang,
      lang: langValue,
      type: typeValue,
      nonce: filterDownloads.nonce,
    },
    success: function (response) {
      downloadsContainer.innerHTML = response.data.downloads;
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.error('Ajax error:', textStatus, errorThrown);
    },
  });
}